export default __webpack_public_path__ + "static/media/about-header.a9f1835e.jpg";